import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const News = lazy(() => import("@/pages/News"));

export const Route = createFileRoute("/nyheter/")({
  head: () => seoHead("/nyheter"),
  component: () => <News />,
});
